export const mainAuthName = "faceAuthTokenData";

// Storing Token in storage
export const setTokens = (data) => {
  if (typeof window !== "undefined") {
    localStorage.setItem(mainAuthName, JSON.stringify(data));
  }
};

// Retrieving Token in storage
export const getToken = () => {
  if (typeof window !== "undefined") {
    const data = localStorage.getItem(mainAuthName);
    return data ? JSON.parse(data) : null;
  }
  return null; // Fallback for server-side execution
};

// Deleting Token in storage
export const deleteToken = () => {
  if (typeof window !== "undefined") {
    localStorage.removeItem(mainAuthName);
  }
};

export const setMobileNumber = (data) => {
  if (typeof window !== "undefined") {
    localStorage.setItem("mobile", data);
  }
};
